import { QueryParameter } from './query-parameter.model';

export class PathQuery {
    private queryParameters: Array<QueryParameter>;

    constructor(params: QueryParameter[]) {
        this.queryParameters = params;
    }

    get QueryParameters(): QueryParameter[] { return this.queryParameters; }
    set QueryParameters(value: QueryParameter[]) { this.queryParameters = value; }

    // public toJSON() {
    //     let query = '';
    //     this.QueryParameters.forEach(qp => {
    //         query = query + `${qp.Param}=${qp.Value}&`;
    //     });
    //     if (query.length > 0) {
    //         query = query.substr(0, query.length - 1);
    //     }
    //     return query;
    // }

    public addQueryParameter(param: string, value: string) {
        this.QueryParameters.push(new QueryParameter(param, value));
    }

    public toQueryParam(): any {
        const queryParams = { };
        if (this.QueryParameters) {
            this.QueryParameters.forEach(qp => {
                queryParams[qp.Param] = qp.Value;
            });
        }
        return queryParams;
    }

    public toString(): string {
        let query = '';
        if (this.QueryParameters) {
            this.QueryParameters.forEach(qp => {
                query = query + `${qp.Param}=${qp.Value}&`;
            });
            if (query.length > 0) {
                query = query.substr(0, query.length - 1);
            }
        }
        return query;
    }
}

